import QualTable from './Table/Table_container';
import QualMediaBlockContainer from './MediaBlock/MediaBlock_container';
import apiServices from './api';

export const api = apiServices;

export const components = {
  QualTable,
  QualMediaBlock: QualMediaBlockContainer
};

export default {
  api,
  components: {
	QualTable,
	QualMediaBlock: QualMediaBlockContainer
  }
};



// WEBPACK FOOTER //
// ./components/qual/index.js